module.exports = __webpack_public_path__ + "img/pko.f22b4a56.svg";